module.exports = __webpack_public_path__ + "static/media/icon_upload_file.93585bcd.svg";